import React, { useState} from "react";
import { Button, Form, Input, Label, Card} from "reactstrap";
import logoCiba from "../../assets/images/logo.png";
import { getContrato, registro, isNew, enviarMailRegistro } from "../../services/api"
// import respuestasFalsas from "./RespuestasFalsas";
import { useHistory } from "react-router";
import { getRespuestasFalsasDomicilio, getRespuestasFalsasNombre, getRespuestasFalsasPlanes } from '../../services/preguntas';

const initialState = { 
  dni: "", 
  msg: "", 
  socio: null, 
  email: null, 
  celular: null
}

const Registro = () => {
  const [state, setState] = useState(initialState);
  const [paso, setPaso] = useState(1);
  const [direcciones, setDirecciones] = useState(getRespuestasFalsasDomicilio());
  const [nombres, setNombres] = useState(getRespuestasFalsasNombre());
  const [planes, setPlanes] = useState(getRespuestasFalsasPlanes());
  const history = useHistory();
  const [loading, setLoading] = useState(false)

  const handleInputChange = async (event) => {
    const target = event.nativeEvent.target;
    const name = target.name;
    const value = target.value;
    await setState({...state,
      [name]: value,
      msg:''
    });

  }

  const handleSearch = async (event) => {
    event.preventDefault();
    const nuevoUser = await isNew(state.dni);
    if(nuevoUser){
      const socio = await getContrato(state.dni);
      if(socio){
        setDirecciones([...direcciones, socio.direccion].sort());
        setNombres([...nombres, socio.apellido_nombres].sort());
        setPlanes([...planes, socio.plan].sort());
        setState({...state, socio})
        setPaso(2)
      }else{
        setPaso(3)
      }
    }else {
      setPaso(0)
    }
  }

  const handleQuestions = (event) => {
    event.preventDefault();
    const { chosenDirection, chosenNames, chosenPlan } = state;
    const { direccion, apellido_nombres, plan } = socio;
    if(
      chosenDirection.trim() === direccion.trim() && 
      chosenNames.trim() === apellido_nombres.trim() && 
      chosenPlan.trim() === plan.trim()
      ){
        setPaso(4)
    }else{
      setPaso(3)
    }
  }

  const handleConfirmRegistro = async (event) => {
    event.preventDefault();
    setLoading(true)
    const response = await registro(state)
    if(response.status === 201){
      await enviarMailRegistro({ email: state.email })
      setPaso(5)
    }
  }


  // ver de sacar para no repetir esto 
  const handlequery = () => {
    return new URLSearchParams(window.location.hash.split("?")[1]);
  };

  const handleRedirect = () => {
    var url = handlequery().get("app");
    if(url){
      window.location.href = url;
    }else{
      history.push('/')
    }
  }

  const { msg, socio, password, passwordRepeat, email } = state;

  return (
    <>
      <img src={logoCiba} className="logoCiba mt-5" alt=""  />
      <Card className="p-4 text-center mt-4">
        <p className="mt-2 title">REGISTRO</p>
        {paso === 0 ? 
          <>
            <p className='my-5 pt-2'>Usted ya se encuentra registrado...</p>
            <Button className="btn btn-continuar" onClick={handleRedirect}>
              VOLVER
            </Button>
          </>
        : paso === 1 ? 
          <Form onSubmit={handleSearch}> 
            <p>
              <Input
                name="dni"
                placeholder="DNI"
                type="text"
                className="inputDni"
                onChange={handleInputChange}
              />
            </p>
            <p >{msg}</p>
            <Button className="btn btn-continuar" type="submit">
              Continuar
            </Button>
          </Form>
        : paso === 2  && socio ? 
          <Form onSubmit={handleQuestions}> 
            <SelectorPreguntas arr={direcciones} name='chosenDirection' action={handleInputChange} label='Su domicilio actual es...'/>
            <SelectorPreguntas arr={nombres} name='chosenNames' action={handleInputChange} label='¿Cual es su nombre completo?' />
            <SelectorPreguntas arr={planes} name='chosenPlan' action={handleInputChange} label='Su plan contratado es...'/>
            <Button 
              className="btn btn-continuar" 
              type="submit"
              disabled={!state?.chosenDirection || !state?.chosenNames || !state?.chosenPlan}
            >
              Continuar
            </Button>
          </Form> 
        : paso === 3 ? 
          <>
            <p className='my-5 pt-2'>La información seleccionada no es correcta</p>
            <Button className="btn btn-continuar" onClick={()=> history.push('/')}>
              Volver
            </Button>
          </>
        : paso === 4 ? 
          <Form onSubmit={handleConfirmRegistro}>
            <p className="mt-5">
              Ingresar contraseña
            </p>
            <p>
              <Input
                name="password"
                placeholder="PASSWORD"
                type="password"
                className="inputDni"
                onChange={handleInputChange}
              />
            </p>
            <p>
              <Input
                name="passwordRepeat"
                placeholder="CONFIRMAR PASSWORD"
                type="password"
                className="inputDni"
                onChange={handleInputChange}

              />
            </p>
            <p>
              <Input
                name="email"
                placeholder="INGRESAR EMAIL"
                type="email"
                className="inputDni"
                onChange={handleInputChange}
                required
              />
            </p>
            <Button 
              className="btn btn-continuar" 
              type="submit" 
              disabled={ !password || password.length < 6 || passwordRepeat !== password || !email || loading}>
              Continuar
            </Button>
            <p>{msg}</p>
          </Form>
        : paso === 5 ? 
          <>
            <p className='my-5 pt-2'>Se ha registrado correctamente</p>
            <Button 
              className="btn btn-continuar" 
              onClick={handleRedirect}
            >
              Ingresar
            </Button>
          </>
        : null}
      </Card>
    </>
  );
}

const SelectorPreguntas = ({action, arr, name, label}) => {
  return(
    <p>
      <Label>{label}</Label>
      <Input type='select' onChange={action} name={name}>
        <option>Seleccionar...</option>
        {arr.map( o => {
          return  <option key={o} value={o}>{o}</option> 
        })}
        
      </Input>
    </p>
  )
}

export default Registro;
